var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarMonth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON/24/Line/Black/Day"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M1.832 6.85192C1.832 5.35854 3.04262 4.14792 4.536 4.14792H12H19.464C20.9574 4.14792 22.168 5.35854 22.168 6.85192V20.9201C22.168 21.6094 21.6093 22.1681 20.92 22.1681H3.08C2.39075 22.1681 1.832 21.6094 1.832 20.9201V6.85192Z",
    stroke: "#2E2E30",
    strokeWidth: 1.664
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M1.57886 9.68442H22.421",
    stroke: "#2E2E30",
    strokeWidth: 1.664
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    d: "M7.3685 1.57895V3.89474",
    stroke: "#2E2E30",
    strokeWidth: 1.664,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 2_2",
    d: "M16.6317 1.57895V3.89474",
    stroke: "#2E2E30",
    strokeWidth: 1.664,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 5.63159,
    y: 12.5791,
    width: 2.54737,
    height: 2.31579,
    fill: "#2E2E30"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 15.821,
    y: 12.5791,
    width: 2.54737,
    height: 2.31579,
    fill: "#2E2E30"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    x: 10.7263,
    y: 12.5791,
    width: 2.54737,
    height: 2.31579,
    fill: "#2E2E30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 2 Copy"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    x: 5.63159,
    y: 17.2104,
    width: 2.54737,
    height: 2.31579,
    fill: "#2E2E30"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    x: 15.821,
    y: 17.2104,
    width: 2.54737,
    height: 2.31579,
    fill: "#2E2E30"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    x: 10.7263,
    y: 17.2104,
    width: 2.54737,
    height: 2.31579,
    fill: "#2E2E30"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMonth);
export default __webpack_public_path__ + "static/media/Calendar_Month.468f7d0e0c777e39a0c5b23c9e69cf4f.svg";
export { ForwardRef as ReactComponent };